export default "__VITE_PUBLIC_ASSET__51c7057e__"